/* JTM - visible seam warning popup */

(function () {

var visibleSeamFirstTriggerCount = 0;

// add html.tour-ready' when using tour
$q('html.is-builder.tour-ready .product-info.cd-builder-ready #cd-step-size .form-list .field:not(.ihidden) input[data-cd-option-name]').wait(true,(elm) => {  

  $q('html.is-builder.tour-ready .visible-seam-warning-optout').wait(true,(elm) => {  

  if(document.querySelector('#itoris_dynamicproductoptions[data-cushion-builder-text="Cushion Builder"]') !== null || isCurtainBuilder){//document.querySelector('#itoris_dynamicproductoptions[data-builder-type="Curtain Builder"]') !== null

  const fabricWidth = document.querySelector('#cd-step-fabric input[data-cd-option-name="cd--fabric-width"]').value;
  //console.log('fabricWidth',fabricWidth);
  let MAX_VALUE = parseFloat(fabricWidth) - 2;// 52 and above
  const COOKIE_NAME = 'visibleSeamWarningOptOut';
  const COOKIE_DAYS = 180;

  if(isCurtainBuilder) {
    MAX_VALUE = 50;
  }
  
  /*
  // Modal elements (assumes you already added the modal + overlay markup)
  const overlay = document.querySelector('.visible-seam-warning-overlay');
  const modal = document.querySelector('.visible-seam-warning-modal');
  const closeBtn = document.querySelector('.visible-seam-warning-close:not(.btn)');
  const closeBtnBtn = document.querySelector('.visible-seam-warning-close.btn');
  */

  const optOutCheckbox = document.querySelectorAll('.visible-seam-warning-optout');
  
  if (!optOutCheckbox.length) return;//!overlay || !modal || !closeBtn || 

  //if(window.console){ console.log('run visible seam check'); }

  // --- Cookie helpers ---

  function deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax`;
  }
  
  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie =
      `${name}=${encodeURIComponent(value)}; expires=${d.toUTCString()}; path=/; SameSite=Lax`;
  }

  function getCookie(name) {
    const needle = name + '=';
    return document.cookie
      .split(';')
      .map(function (s) { return s.trim(); })
      .find(function (s) { return s.startsWith(needle); })
      ?.slice(needle.length) || null;
  }

  function isOptedOut() {
    return getCookie(COOKIE_NAME) === '1';
  }

  function isAnyOptOutChecked() {
    let i = 0;

    for (i = 0; i < optOutCheckbox.length; i++) {
      if (optOutCheckbox[i].checked) {
        return true;
      }
    }

    return false;
  }

  function syncOptOutCheckboxes(isChecked, changedEl) {
    let i = 0;

    for (i = 0; i < optOutCheckbox.length; i++) {
      if (changedEl && optOutCheckbox[i] === changedEl) {
        continue;
      }

      optOutCheckbox[i].checked = isChecked;
    }
  }

  // --- Match only inputs whose data-cd-option-name contains these keywords ---
  // Example attribute: data-cd-option-name="cd--seat-width"
  function shouldRunForInput(el) {
    const attr = el?.dataset?.cdOptionName;
    if (!attr) return false;
    //return /(depth|length|width|height)/i.test(attr);
    return /(width)/i.test(attr);
  }

  // --- Popup controls ---
  /* function showPopup() {
    if (isOptedOut()) return;

    overlay.hidden = false;
    modal.hidden = false;

    requestAnimationFrame(() => {
      overlay.classList.add('is-visible');
      modal.classList.add('is-visible');
    });
  }*/

  function hidePopup() {
    // Persist opt-out only if user checked the box
    if (isAnyOptOutChecked()) {
      syncOptOutCheckboxes(true);
      setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
    }

    //overlay.classList.remove('is-visible');
    //modal.classList.remove('is-visible');

    //setTimeout(() => {
    //  overlay.hidden = true;
    //  modal.hidden = true;
    //}, 350);
  }

  // ✅ Checks value and shows popup if needed
  function checkValueAndMaybeShow(inputEl) {
    if (isOptedOut()) return;
    if (!shouldRunForInput(inputEl)) return;
    if ((inputEl.dataset.cdOptionName === 'cd--back-lower-width') || (inputEl.dataset.cdOptionName === 'cd--fabric-width') || (inputEl.dataset.cdOptionName === 'cd--welt-width')) return;


    const raw = (inputEl.value ?? '').toString().trim();
    if (!raw) return;

    const val = parseFloat(raw);
    if (Number.isNaN(val)) return;

    MAX_VALUE = parseFloat(document.querySelector('#cd-step-fabric input[data-cd-option-name="cd--fabric-width"]').value);
    MAX_VALUE = (MAX_VALUE - 2);// 52 and above
    if(isCurtainBuilder) {
      MAX_VALUE = 50;
    }
    if (val > MAX_VALUE) {
      //showPopup();
      
      //console.log('MAX_VALUE',MAX_VALUE);
      //console.log('inputEl',inputEl);

      /* if(document.querySelector('html.is-iphone') || document.querySelector('html.is-ipad') || document.querySelector('html.is-chrome-ios')){
        
        $q('#visible-seam-notice-trigger').click();

      } else  */if(window.tourMain && typeof window.tourMain.openStep === 'function'){
        
          //console.log("visible-seam-notice");
          if (window.tourMain && window.tourMain.isOpen === true && window.tourMain._standalone && document.querySelector('html.tour-active .cb-tour-popover.is-visible input.visible-seam-warning-optout') !== null) {
            return;
          }
          window.tourMain.openStep(
            "visible-seam-notice",
            { target: inputEl, trigger: "#cd-step-size-label", fake: false, useGuards: true },
            { openerEl: inputEl, restoreFocus: false, showClose: true, closeOnOverlay: true, autoCloseMs: 0 },
          );
          /*visibleSeamFirstTriggerCount = 1;
          if (optOutCheckbox && !optOutCheckbox.checked) {
            optOutCheckbox.checked = true;
            setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
            // optional: notify any listeners/UI that rely on change
            optOutCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
          }*/
      } //else {
        //$q('#visible-seam-notice-trigger').click();
      //}

      // auto-opt-out after first trigger
      /* if (visibleSeamFirstTriggerCount == 0) {
        visibleSeamFirstTriggerCount = 1;
        if (optOutCheckbox && !optOutCheckbox.checked) {
          optOutCheckbox.checked = true;
          setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
          // optional: notify any listeners/UI that rely on change
          optOutCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } */
    }
  }

  if(document.querySelector('#builder-drawer')){
    document.querySelector('body').addEventListener('change', (e) => {
      e.preventDefault();

      if (!e.target.closest('.visible-seam-warning-optout')) {
        return;
      }

      if (e.target.checked) {
        syncOptOutCheckboxes(true, e.target);
        hidePopup();
      } else {
        syncOptOutCheckboxes(false, e.target);
        deleteCookie('visibleSeamWarningOptOut');
      }
    });
  }

  if(getCookie(COOKIE_NAME) === '1'){
    //$q('.visible-seam-notice-cookie-opt-out').classList.add('hide');
    syncOptOutCheckboxes(true);
  }

  // --- Close handlers ---
  /* closeBtn.addEventListener('click', (e) => {
    e.preventDefault();
    hidePopup();
  });

  closeBtnBtn.addEventListener('click', (e) => {
    e.preventDefault();
    hidePopup();
  });

  overlay.addEventListener('click', hidePopup);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.hidden) hidePopup();
  }); */

  // --- Event delegation: input + keyup + blur (capture for mobile reliability) ---
  function handler(e) {
    const target = e.target;
    if (!(target instanceof HTMLInputElement)) return;
    checkValueAndMaybeShow(target);
  }

  const sizeBox = document.querySelector('#cd-step-size');

  document.addEventListener('input', handler);
  document.addEventListener('keyup', handler);
  document.addEventListener('blur', handler, true);
}

}); // wait for opt in checkbox

}); // and wait for builder ready

})();